import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export enum ActionBarCardTypes {
  ApprovedProducts = "approved_products",
}

interface ActionBarCardEntityParams {
  card_type: string;
}

export class ActionBarCardEntity extends BaseEntityClass {
  card_type: string;
  constructor(params: ActionBarCardEntityParams) {
    super();
    this.type = "action_bar_card";
    this.entity_version = 1;
    this.card_type = params.card_type;
  }
}
